const initBanner = () => {
	const heroBanner = document.querySelector( 'div.hero-banner' );
	
	if ( !heroBanner )
	{
		return;
	}

	const checkButton = heroBanner.querySelector( 'button.close' ); 

	checkButton.addEventListener( 'click', () => {
		const elemOffset = window.innerWidth > 1024 ? 16 : 32;

		heroBanner.classList.add( 'active' );
		heroBanner.style.marginTop = `-${heroBanner.offsetHeight + elemOffset}px`;

		setTimeout( () => heroBanner.remove(), 500 );

		const domain = location.host;
		document.cookie = `cds_visit=read; domain=${domain}; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
	} );
};

export {
	initBanner,
}
